import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { CustomButton } from 'components'
import { Form, Input, Checkbox } from 'antd'
import { editProfile, logout } from 'modules/session/session-actions'
import { useQuery } from 'utils'
import { goAfterSignIn } from 'utils/sessionSharing'
import backArrow from 'images/back-arrow-auth.svg'

import './index.styl'

const { Item } = Form

const CompleteAccount = () => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const query = useQuery()
  const redirectTo = query.get('redirectTo') || '/home'

  const onFinish = form => {
    setLoading(true)
    dispatch(editProfile({ mobile: form.mobile.trim(), countryCode: '+1' }))
      .then(() => {
        setLoading(false)
        goAfterSignIn(history, redirectTo)
      })
      .catch(() => setLoading(false))
  }

  const onPressSpace = e => {
    if (e.key === ' ') {
      e.preventDefault()
    }
  }

  const checkboxValidate = (_, value) =>
    value
      ? Promise.resolve()
      : Promise.reject(new Error('Please agree to Terms & Conditions'))

  return (
    <div className='wrapperCompleteAccount'>
      <div className='title'>Complete Your Account</div>
      <div className='subtitle'>We just need a few more details</div>
      <Form layout='vertical' className='formCompleteAccount' onFinish={onFinish}>
        <Item
          name='mobile'
          label='Phone Number'
          rules={[
            { required: true, whitespace: true, message: 'Please enter phone number' },
            { min: 5, message: 'Phone number must be at least 5 characters.' },
          ]}
          validateTrigger='onBlur'
        >
          <Input prefix='+1' onKeyDown={onPressSpace} className='input' type='number' />
        </Item>
        <div className='checkbox'>
          <Item
            name='agreement'
            valuePropName='checked'
            rules={[{ validator: checkboxValidate }]}
          >
            <Checkbox>
              I Accept{' '}
              <Link className='link' to='/help/terms-and-conditions'>
                Terms & Condition
              </Link>
            </Checkbox>
          </Item>
        </div>
        <CustomButton
          text='Create Account'
          type='dark'
          className='createAccountButton'
          htmlType='submit'
          loading={loading}
        />
        <div className='backLinkWrapper'>
          <div
            className='backLink' onClick={() => {
              dispatch(logout())
              history.push('/auth/sign-up')
            }}
          >
            <img src={backArrow} alt='' className='backArrow' />
            Back
          </div>
        </div>
      </Form>
    </div>
  )
}

export default CompleteAccount
